const ns_groups = {
	how_to_use_section: `Dit zijn alles of niets instellingen. Dus de ene naam niet en andere domeinnaam wel, gaat niet.
		Klant heeft eigen nameservers? Dan kunnen zij niet hun DNS beheren in Portal.
		Klant wil onze nameservers gebruiken met een eigen naam?
		
		Breng een engineer op de hoogte dat je dat gaat doen en laat de namen weten (bijv. n1.klantnaam.nl en ns2.klantnaam.nl. Klantnaam.nl moet bij ons staan!)
		Maak in OXXA een nameserver-groep aan met die namen
		Wacht op akkoord van de engineer.
		Voeg daarna die nameserver-groep in Portal toe en koppel die aan de debiteur

		Stel je niets in, dan worden standaard de nameservers van Tuxis gebruikt wat de gewenste instelling is. 
		Wijzig je deze instelling tussendoor, dan gaat die gelden voor alle nieuwe registraties. Oude registraties worden niet aangepast. 
		Je kan bij OXXA dus ook een nameserver-groep verwijderen.`,
	table: {
		headers: {
			alias: "Alias",
			company: "Bedrijf",
			debtor: "Debiteur",
			is_external: "Eigen nameservers?",
			ns_overview: " Overzicht van nameservers",
			oxxa_handle: "Oxxa handle",
		},
	},
	title: "Custom NS-groepen",
};

export default ns_groups;
